import { IOConnectBrowser } from "@interopio/browser";
import { IOConnectBrowserPlatform } from "@interopio/browser-platform";

export const start = async (io: IOConnectBrowser.API, config: any, platform: IOConnectBrowserPlatform.Plugins.PlatformControls): Promise<void> => {
    const userEmail = config?.user?.email;

    if (!userEmail) {
        return;
    }

    const localStorageKey = `io-sandbox-user-${userEmail}`;

    const localStorageUserData = localStorage.getItem(localStorageKey);

    const parsedUserData = localStorageUserData ? JSON.parse(localStorageUserData) : {};
    
    const importedApps = parsedUserData.importedApps || [];
    
    if (!importedApps.length) {
        return;
    }

    await io.appManager.inMemory.import(importedApps, "merge");
};
